import { render, staticRenderFns } from "./ModalPayrollAccounting.vue?vue&type=template&id=13c467ec"
import script from "./ModalPayrollAccounting.vue?vue&type=script&lang=ts"
export * from "./ModalPayrollAccounting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports